<script>
import baseMixin from '@mixins/baseMixin'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'TheDrawerMinifier',
  mixins: [baseMixin],
  computed: {
    ...mapGetters({
      mini: 'isDrawerOpen',
    }),
  },
  methods: {
    ...mapActions({
      toggleMiniDrawer: 'toggleDrawer',
    }),
  },
}
</script>

<template>
  <div>
    <v-divider class="opacity-6"></v-divider>
    <div class="d-flex flex-row-reverse">
      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            id="open-navbar-toggler-icon"
            class="navbar-toggler-icon pa-7"
            tile
            icon
            v-bind="attrs"
            @click.stop="toggleMiniDrawer"
            v-on="on"
          >
            <v-icon
              v-text="
                !mini ? 'mdi-chevron-double-left' : 'mdi-chevron-double-right'
              "
            ></v-icon>
          </v-btn>
        </template>
        <span v-text="!mini ? 'Show Less' : 'Show More'"></span>
      </v-tooltip>
    </div>
  </div>
</template>
